var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('horizontal-scroll',[(_vm.getPackages)?_c('transition-group',{staticClass:"flex flex-row gap-x-6",attrs:{"name":"fade-up-down"}},_vm._l((_vm.getPackages),function(packageData){return _c('package-card',{key:packageData.id,attrs:{"package-data":packageData},on:{"added":function($event){return _vm.$emit('added')}}})}),1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }